<template>
  <div class="px-4 py-3">
    <CRow>
      <CCol sm="12">
        <CRow v-if="loading">
          <CCol class="d-flex flex-column justify-content-center align-items-center w-100">
            <CSpinner class="my-3" color="primary" />
          </CCol>
        </CRow>

        <CRow class="justify-content-between align-items-start" v-show="!loading">
          <CCol v-if="messages.length" sm="12">
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>

          <CCol v-else v-for="target in targets" :key="target.id" sm="6" class="p-0 text-gray-600 cardChannel">
            <CInputRadio
              type="radio"
              :id="target.name"
              :value="target.name"
              name="target"
              :checked="targetAudienceType == target.name"
              @update:checked="(b) => check(b, target.name)"
              class="cardChannel__checkRadio"
              :class="{
                'cardChannel__checkRadio--active': targetAudienceType == target.name,
              }"
              hidden
            />

            <div
              class="cardChannel__child m-1"
              :class="{ '--disabled': segmentsOptDisabledTooltip(target.name) }"
              v-c-tooltip="segmentsOptDisabledTooltip(target.name)"
            >
              <div :class="{ 'pointer-events-none': isSegmentsOptDisabled(target.name) }">
                <label :for="target.name" class="d-flex justify-content-center align-items-center flex-column p-2">
                  <CIcon :name="target.name" :height="32" viewBox="0 0 32 32" />
                  <span class="font-weight-normal font-md text-center">
                    {{ $t(`sidebar.blocksLibrary.campaign.component.target.options.label.${target.name}`) }}
                  </span>
                </label>
              </div>
            </div>
          </CCol>
          <!-- 
          <CCol class="my-3">
            <CInputCheckbox
              :checked="override"
              @update:checked="(value) => checked(value)"
              :label="$t(`sidebar.blocksLibrary.campaign.component.target.options.label.override-unsubscribed-contacts`)"
              custom
              addLabelClasses="text-gray-600 d-flex align-items-center"
              value.sync="override"
              data-id="teste"
            />
          </CCol> -->

          <transition name="fade">
            <CCol sm="12" v-if="targetAudienceType == 'segments'" class="my-4 p-0">
              <h6 class="mb-2">
                {{ $t(`sidebar.blocksLibrary.campaign.component.target.options.label.content-segments`) }}
              </h6>
              <multiselect
                v-model="segments"
                :multiple="true"
                :options="options"
                :customLabel="customLabel"
                :show-labels="false"
                @input="selectSegment"
                class="multiselect--custom"
                custom
                :placeholder="$t(`sidebar.blocksLibrary.campaign.component.target.options.label.select-one`)"
                label="segmentId"
                track-by="segmentId"
              >
              </multiselect>
            </CCol>
          </transition>

          <CCol sm="12" class="d-flex justify-content-between p-0" v-if="targetAudienceType == 'segments'">
            <CButton color="primary" class="text-uppercase font-sm" v-show="$route.params.campaignId" @click="newSegments(channel)">{{
              $t(`sidebar.blocksLibrary.campaign.component.target.options.button.new-segments`)
            }}</CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import { FIELD_TYPE } from '../constants'

export default {
  name_: 'Audience',

  components: {
    MenssageAlert,
  },

  // props: {
  //   audience: {
  //     type: Object,
  //   },

  //   channel: {
  //     type: Object,
  //     required: true,
  //   },
  // },

  data() {
    return {
      loading: true,
      segments: undefined,
      override: false,
      options: [],
      targetAudienceType: '',
      targets: [{ name: 'allAudience' }, { name: 'segments' }],
      messages: [],
    }
  },

  mounted() {
    this.getClientSegmentsList()
  },

  // updated() {
  //   this.resetValues()
  // },

  // destroy() {
  //   this.$nextTick(function () {}.bind(this))
  // },

  methods: {
    isSegmentsOptDisabled(targetName) {
      return targetName == this.targets[1].name && this.options.length == 0
    },
    segmentsOptDisabledTooltip(targetName) {
      let content = ''
      content = this.isSegmentsOptDisabled(targetName) ? this.$t('automation.audience.segments.tooltip.disabled') : null

      return content
        ? {
            content,
            placement: 'bottom',
          }
        : ''
    },
    customLabel(option) {
      return `${option.name}`
    },

    check(value, name) {
      if (value) {
        const isAllAudience = name == this.targets[0].name
        this.segments = isAllAudience ? [] : null

        this.targetAudienceType = name

        let obj = {
          property: 'segmentId',
          value: this.segments,
          type: FIELD_TYPE.TRIGGER,
        }

        this.$emit('update-field', obj)
        // this.saveSegments()
      }
    },

    selectSegment() {
      let obj = {
        property: 'segmentId',
        value: this.segments.length == 0 ? null : this.segments.map((el) => el.segmentId),
        type: FIELD_TYPE.TRIGGER,
      }

      this.$emit('update-field', obj)
    },

    checked(value) {
      this.override = value
      // this.saveSegments()
    },

    getClientSegmentsList() {
      this.loading = true
      this.messages = []
      let organizationId = this.$route.params.organizationId

      services
        .getClientSegmentsList(organizationId, 0, 10000)
        .then((response) => {
          this.options = response.data.data.segments
          let segmentsId = this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0].data.segmentId
          if (segmentsId != null) {
            if (segmentsId.length > 0) {
              this.targetAudienceType = 'segments'
              this.segments = this.options.filter((el) => segmentsId.includes(el.segmentId))
            } else {
              this.targetAudienceType = 'allAudience'
              this.segments = []
            }
          }
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.data.message || 'erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    // async getTotalAudience(typeChannel, segmentsIds) {
    //   try {
    //     let total = await services.getTotalAudience(this.organizationId, typeChannel, segmentsIds, this.override)
    //     this.loading = false
    //     return total.data.data
    //   } catch (error) {
    //     this.loading = false
    //     return 'Calculando...'
    //   }
    // },

    // async saveSegments() {
    //   this.loading = true
    //   this.messages = []

    //   let options = {
    //     // audience: this.getIdsSegments(this.segments),
    //     segments: this.getIdsSegments(this.segments),
    //     indice: this.channel.indexChannel,
    //     override: this.override,
    //     targetAudienceType: this.targetAudienceType,
    //   }

    //   try {
    //     let typeChannel = this.enumChannelType(this.channel.type)
    //     let segmentsIds = this.getIdsSegments(this.segments, true)
    //     // let total = await this.getTotalAudience(typeChannel, segmentsIds)
    //     options.totalContacts = total
    //   } catch (error) {
    //     this.messages.push({
    //       status: 'danger',
    //       text: error,
    //     })
    //   } finally {
    //     this.loading = false
    //   }
    // },

    newSegments() {
      this.$router.push({
        name: 'segment-create',
        params: {
          channel: this.channel,
        },
      })
    },

    enumChannelType(typeChannelString) {
      const typeList = {
        EMAIL: 1,
        SMS: 2,
      }
      return typeList[typeChannelString] || null
    },

    resetValues() {
      this.segments = this.audience.segments || []
      this.override = this.audience.override || false
      this.targetAudienceType = this.audience.targetAudienceType || ''
    },

    getIdsSegments(segments, onlyId = false) {
      if (!segments.length) {
        return []
      }

      if (onlyId) {
        return segments.map((segment) => `segments=${segment.segmentId}`).join('&')
      }

      return segments.map((segment) => {
        return { segmentId: segment.segmentId, name: segment.name }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cardChannel__child {
  &.--disabled {
    cursor: not-allowed
  }
}
</style>
